import React from "react";
import { Modal } from "react-bootstrap";
import { X, AlertTriangle } from "lucide-react";

const DeleteConfirmationModal = ({ show, onHide, onConfirm, rowData, isDeleting = false }) => {
  const handleConfirm = () => {
    if (onConfirm && rowData) {
      onConfirm(rowData);
    }
  };

  const documentId = rowData?.documentId || rowData?.fullData?.invoice_details?.invoice_number || rowData?.fullData?.document_name || "this item";

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header style={{ borderBottom: "1px solid #e5e7eb", padding: "16px 20px" }}>
        <Modal.Title style={{ fontSize: "18px", fontWeight: 600, display: "flex", alignItems: "center", gap: "8px" }}>
          <AlertTriangle size={20} style={{ color: "#ef4444" }} />
          Confirm Delete
        </Modal.Title>
        <button
          onClick={onHide}
          disabled={isDeleting}
          style={{
            background: "none",
            border: "none",
            cursor: isDeleting ? "not-allowed" : "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
            opacity: isDeleting ? 0.5 : 1,
          }}
        >
          <X size={20} />
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: "24px 20px" }}>
        <p style={{ fontSize: "14px", color: "#374151", margin: 0 }}>
          Are you sure you want to delete <strong>{documentId}</strong>? This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "1px solid #e5e7eb", padding: "16px 20px" }}>
        <button
          onClick={onHide}
          disabled={isDeleting}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            backgroundColor: "white",
            color: "#374151",
            cursor: isDeleting ? "not-allowed" : "pointer",
            opacity: isDeleting ? 0.5 : 1,
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleConfirm}
          disabled={isDeleting}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            border: "none",
            borderRadius: "8px",
            backgroundColor: isDeleting ? "#9ca3af" : "#ef4444",
            color: "white",
            cursor: isDeleting ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {isDeleting ? (
            <>
              <div
                style={{
                  width: "14px",
                  height: "14px",
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderTop: "2px solid white",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                }}
              />
              Deleting...
            </>
          ) : (
            "Delete"
          )}
        </button>
      </Modal.Footer>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </Modal>
  );
};

export default DeleteConfirmationModal;

